import React, { useState } from 'react';
import { AddressElement, Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { NotificationManager } from 'react-notifications';

import { useApi } from '../../../hooks/useApi';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import ModalComponent from './ModalComponent';

import './_modalComponent.scss';

import { GLEAP_CARD_FAILED_FORM_KEY } from '@/utils/ts/gleap';
import { loadStripe } from '@stripe/stripe-js';
import Gleap from 'gleap';
import { useSelector } from 'react-redux';

import { useStripeEnv } from '../../../hooks/useStripeVersion';
import SaralLoader from '../../../images/saral-loader.gif';
import { reSubscribeUserForSubscription } from '../../../services/payment.service';
import { handleLogout } from '../../../utils/global';
import CustomerChatIcon from '../../Icons/icons/CustomerChatIcon';
import LogoutIconButtonIcon from '../../Icons/icons/LogoutButtonIcon';

const ResubscriptionPaymentModal = ({ show, onClose, onPaymentSuccess }) => {
  const { userDetails } = useSelector((s) => s.user);
  const stripeEnv = useStripeEnv();
  const stripe = loadStripe(stripeEnv);
  const [clientSecret, setClientSecret] = useState();
  const [loadingFailed, setLoadingFailed] = useState(false);

  const { isLoading } = useApi(reSubscribeUserForSubscription, {
    onSuccess: (data) => {
      setClientSecret(data?.data?.clientSecret);
    },
    onError: (error) => {
      supportClick();
      setLoadingFailed(true);
    },
  });

  const supportClick = () => {
    Gleap.setTicketAttribute('Intent', 'Hey my card failed, need support!');
    Gleap.startClassicForm(GLEAP_CARD_FAILED_FORM_KEY, true);
  };

  const appearance = {
    theme: 'stripe',
    variables: { borderRadius: '4px' },
    rules: {
      '.TermsText': {
        display: 'none',
        visibility: 'hidden',
        height: 0,
        marginBottom: 10,
      },
      '.Label': { color: '#667085' },
      '.Input': { width: '100%' },
      '.p-TermsText': { display: 'none' },
    },
  };
  const options = {
    clientSecret,
    appearance,
  };
  return (
    <>
      <ModalComponent show={show} onClose={onClose} width={1250} outsideClickClose={false}>
        <div className="resubscription-payment-modal-container">
          <div className="resubscription-payment-modal-header">
            <div className="resubscription-payment-modal-title">Oh no! Your Card Failed</div>
            <div className="resubscription-payment-modal-sub-title">
              It looks like there is a problem with your card on file.
              <br /> We tried billing your card three times, but were unsuccessful.
            </div>
          </div>
          <div className="resubscription-payment-modal-card">
            <div className="resubscription-left-section">
              <div className="resubscription-left-section-title">
                Don’t worry, your emails are preserved, and we’re actively tracking performance!
              </div>
              <div className="resubscription-left-section-description">
                Add a new card to your account and we’ll get out of your way.
              </div>
              <i className="resubscription-left-section-description">
                You will be charged ${userDetails?.plan?.price} towards your pending invoice.
              </i>
            </div>
            {isLoading ? (
              <div className="resubscription-right-loader">
                <img className="saral-loader-img" alt="" src={SaralLoader} width="70" />
              </div>
            ) : (
              <div className="resubscription-right-section">
                {!loadingFailed && (
                  <Elements options={options} stripe={stripe}>
                    <CheckoutForm onPaymentSuccess={onPaymentSuccess} />
                  </Elements>
                )}
              </div>
            )}
          </div>
          <div className="resubscription-reach-out-button" onClick={supportClick}>
            <CustomerChatIcon />
            Reach out to Customer Support
          </div>
          <div className="resubscription-logout-button" onClick={handleLogout} type="button">
            <LogoutIconButtonIcon />
            Logout
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

const CheckoutForm = ({ onPaymentSuccess }) => {
  const stripeEnv = useStripeEnv();
  const loadStripeFromEnv = loadStripe(stripeEnv);
  const stripe = useStripe(loadStripeFromEnv);
  const elements = useElements();
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPayment(true);
    const data = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: `${window.location.origin.toString()}/dashboard`,
      },
    });

    const defaultError = 'An unexpected error occurred.';
    if (data?.error) {
      if (data.error?.type === 'card_error' || data.error?.type === 'validation_error') {
        NotificationManager.error(data?.error?.message || defaultError, '', 1200);
      } else {
        NotificationManager.error(defaultError, '', 1200);
      }
      setIsSubmittingPayment(false);
    } else {
      setTimeout(() => {
        setIsSubmittingPayment(false);
        onPaymentSuccess?.();
      }, 5000);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <AddressElement
        options={{
          mode: 'billing',
          autocomplete: { mode: 'disabled' },
        }}
      />
      <div className="subscription-payment-buttons">
        <ButtonComponent type="submit" style={{ flex: 1 }} showLoading={isSubmittingPayment}>
          Try This Card
        </ButtonComponent>
      </div>
    </form>
  );
};

export default ResubscriptionPaymentModal;
